import Skeleton from "react-loading-skeleton";
import { CardFrame } from "../../../../../common/components/card-frame/CardFrame";
import styles from "./postpaid-bill-history-card.module.scss";

export const PostpaidBillHistoryCardSkeleton = () => {
	return (
		<CardFrame>
			<div className={styles.inner}>
				<div className={styles.row}>
					<div className={styles.col}>
						<span className={styles.label}>Last Billed Amount</span>
						<Skeleton width={120} height={22} />
					</div>
					<div className={styles.colDivider} />
					<div className={styles.col}>
						<span className={styles.label}>Outstanding Balance</span>
						<Skeleton width={100} height={22} />
					</div>
				</div>
				<div className={styles.divider} />
				<div className={styles.row}>
					<div className={styles.col}>
						<span className={styles.label}>Last Payment</span>
						<Skeleton width={110} height={22} />
					</div>
					<button disabled className={`${styles.viewBillButton} ${styles.viewBillButtonDisabled}`}>
						View Bill
					</button>
				</div>
			</div>
		</CardFrame>
	);
};
